// @ts-nocheck
const scrollToBottom = (id: string, step?: number) => {
    const idToScrollTo = document.getElementById(id);
    const viewportPosition = idToScrollTo?.getBoundingClientRect().bottom || 0;
    const viewportToDocument = window.scrollY;
    const scrollTopPx = viewportPosition + viewportToDocument;

    window.scrollTo({
        top: scrollTopPx - (step || 0),
        behavior: "smooth",
    });
};

export default scrollToBottom;
